import Logo from '../../../assets/logo/logo.png'

const Shadow = props => {
    return <div className="container fluid py-2" id="shadow">

        <div className="container fluid">
            <p className="text xl"><a href="#shadow" className="link">&#128279;</a> Shadow</p>
            <p className="text md">
                Shadow classes applies different <code>box-shadow</code> properties to a HTML element.
        </p>
        </div>

        <div className="spacer md"></div>

        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                            <th>Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.shadow-sm, .shadow-md, .shadow-lg, .shadow-xl, .shadow-xxl</code>
                            </td>
                            <td>Creates dark shadow</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Shadow</label>
                                    <select onChange={(e) => props.helper('shadow-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value={"shadow-sm"}>shadow-sm</option>
                                        <option value={"shadow-md"}>shadow-md</option>
                                        <option value={"shadow-lg"}>shadow-lg</option>
                                        <option value={"shadow-xl"}>shadow-xl</option>
                                        <option value={"shadow-xxl"}>shadow-xxl</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <code>.shadow-rb, .shadow-lb, .shadow-lt, .shadow-rt</code>
                            </td>
                            <td>Creates dark shadow</td>
                            <td>

                                <div className="form-item sm">
                                    <label>Shadow</label>
                                    <select onChange={(e) => props.helper('shadow-display', '', '', e)}>
                                        <option defaultValue>select a value</option>
                                        <option value={"shadow-rb"}>shadow-rb</option>
                                        <option value={"shadow-lb"}>shadow-lb</option>
                                        <option value={"shadow-lt"}>shadow-lt</option>
                                        <option value={"shadow-rt"}>shadow-rt</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="spacer md"></div>

        <div className="container sm">
            <div className="border-dark min-h25 align-items-center justify-content-center">
                <img src={Logo} alt="POKE-CSS-LOGO" style={{ width: '100px', height: '100px' }} id="shadow-display" />
            </div>
        </div>

    </div>
}

export default Shadow